<template>
  <div v-if="adminInfo">
    <AdminHeader :adminID="route.params.adminID"/>
    <div class="admin-wrap">
      <div class="space-list-scroll">
        <!--電腦版-->
        <div v-if="!isMobile"
             class="pc-wrap">
          <div v-if="adminInfo.banner"
               class="banner">
            <img :src="picUrl + adminInfo.banner"
                 alt="廠商橫幅圖"/>
          </div>

          <div class="my-4 flex items-center justify-between">
            <!--          logo-->
            <div class="flex">
              <NuxtImg v-if="adminInfo.logo"
                       format="webp"
                       loading="lazy"
                       height="90"
                       class="admin-logo"
                       :src="picUrl + adminInfo.logo"
                       alt="logo"/>
              <h1 class="ml-3 brand-name">{{ adminInfo.brand_name }}</h1>
            </div>

            <!-- line  fb-->
            <div class="flex">
              <NuxtLink v-if="adminInfo.facebook"
                        :to="adminInfo.facebook"
                        target="_blank">
                <svg-icon
                    class="mr-[8px] cursor-pointer"
                    name="fb"
                    size="30"
                />
              </NuxtLink>
              <NuxtLink v-if="adminInfo.line"
                        :to="getLineUrl(adminInfo.line)"
                        target="_blank">
                <svg-icon
                    class="cursor-pointer"
                    name="line"
                    size="30"
                />
              </NuxtLink>
            </div>
          </div>


          <div v-if="adminInfo.banner_text"
               class="divide-y mb-[38px]">
            <div></div>
            <div class="banner-text">{{ adminInfo.banner_text }}</div>
            <div></div>
          </div>

          <!--        <div class="w-full h-[1px] bg-osn-grey-03"></div>-->
          <!-- 空間列表 -->
          <div v-if="spaceList.length">
            <div v-for="(dataObj,index) in spaceList"
                 :key="'spaceList-key-'+index">
              <AdminSpaceCardPC :data-obj="dataObj"></AdminSpaceCardPC>
              <div class="w-full h-[1px] bg-osn-grey-03"></div>
            </div>
          </div>

        </div>

        <!--手機版-->
        <div v-else
             class="space-wrap">

          <div v-if="adminInfo.banner"
               class="banner">
            <img :src="picUrl + adminInfo.banner"
                 alt="廠商橫幅圖"/>
          </div>
          <div class="mt-3 flex items-center justify-between">
            <div>
              <NuxtImg v-if="adminInfo.logo"
                       format="webp"
                       loading="lazy"
                       height="50"
                       :src="picUrl + adminInfo.logo"
                       alt="logo"/>
            </div>
            <div class="flex">
              <NuxtLink v-if="adminInfo.facebook"
                        :to="adminInfo.facebook"
                        target="_blank">
                <svg-icon
                    class="mr-[8px] cursor-pointer"
                    name="fb"
                    size="30"
                />
              </NuxtLink>
              <NuxtLink v-if="adminInfo.line"
                        :to="getLineUrl(adminInfo.line)"
                        target="_blank">
                <svg-icon
                    class="cursor-pointer"
                    name="line"
                    size="30"
                />
              </NuxtLink>
            </div>
          </div>
          <h1 class="brand-name">{{ adminInfo.brand_name }}</h1>
          <div v-if="adminInfo.banner_text"
               class="divide-y mt-2 mb-4">
            <div></div>
            <div class="banner-text">{{ adminInfo.banner_text }}</div>
            <div></div>
          </div>


<!--          todo 抽出來comp -->
          <div v-for="(dataObj,index) in spaceList"
               :key="'spaceList-key-'+index">
            <AdminSpaceCardPC :data-obj="dataObj"></AdminSpaceCardPC>
<!--            <div class="img-wrap">
              <swiper :modules="[SwiperPagination]"
                      :loop="dataObj.photos.length > 1"
                      :pagination="true"
                      :slides-per-view="1">
                <swiper-slide v-for="(spaceImg,photoIndex) in  dataObj.photos"
                              :key="picUrl+photoIndex">
                  <div class="">
                    <img :src="picUrl+spaceImg.url"
                         alt="空間照片"
                         @click="handleSpaceDetail(dataObj.space_id)">
                    <div class="tag-wrap">
                      <div v-for="tag in handleSpaceTypeArray(dataObj.categories)"
                           class="tag">{{ tag.name }}
                      </div>
                      <div class="tag">{{ dataObj.number_of_people_max + '人' }}</div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="space-info">
              <div class="top-wrap">
                <div class="space_name">{{ dataObj.name }}</div>
                <div class="rent-wrap">
                  <div v-for="(price, type, index) in getTypePrice(dataObj.rent.rent_groups)"
                       class="rent-type">
                    {{ parseRentType(type) }}
                  </div>
                </div>
              </div>
              <div class="bottom-wrap">
                <div class="left-wrap">
                  <div class="address">{{ dataObj.city + dataObj.region + dataObj.address }}</div>
                  <div class="address">{{ parseRentMRT(dataObj.traffic) }}</div>
                  <div class="price">
                    {{
                      parseFormatCheapestRentPrice(dataObj.rent.rent_groups) + ' / ' + parseFormatCheapestRentType(dataObj.rent.rent_groups)
                    }}
                  </div>
                </div>
                <div class="right-wrap">
                  <div class="booking-button point"
                       @click="handleSpaceDetail(dataObj.space_id)">{{ $t('booking_right_now') }}
                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>

      </div>
      <!--    <AdminFooter/>-->
    </div>
    <Footer class="bg-osn-grey-03"></Footer>
  </div>
  <div v-else>廠商不存在</div>
</template>
<script setup>

import {onMounted, ref} from "vue";
import {getSpaceList} from "@/api/space";
import {getAdminInfo} from "@/api/website";
import 'swiper/css';
import 'swiper/css/pagination';

import AdminHeader from "@/components/AdminHomePage/AdminHeader.vue"
import AdminSpaceCardPC from "~/components/AdminHomePage/AdminSpaceCardPC.vue"
import {useSettingStore} from "@/stores/setting";
import AdminFooter from "@/components/AdminHomePage/AdminFooter.vue";
import Footer from "@/components/Footer/Footer.vue";
import {useGoTo} from "@/composables/useGoTo";
import {
  getMinShortestRentalDuration,
  getTypePrice,
  parseFormatCheapestRentPrice,
  parseFormatCheapestRentType
} from "~/utils/newPriceTool.ts";


const isMobile = ref(false)

const router = useRouter()
const route = useRoute();
const settingStore = useSettingStore()
const {serverGoHome} = useGoTo();

const adminInfo = ref({
  "brand_name": "",
  "logo": "",
  "qr_code": "",
  "area_code": "",
  "phone": "",
  "email": "",
  "facebook": "",
  "line": "",
  "youtube": "",
  "instagram": "",
  "twitter": "",
  "website": "",
  "can_reservation": true,
  "can_view": true,
  "contract": "",
  "atm_enabled": true
})
const spaceList = ref([])

const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const lineUrl = ref('line://ti/p/@768cpmhz?oat_referrer=PROFILE')


function getLineUrl(lineID) {
  return `line://ti/p/${lineID}?oat_referrer=PROFILE`
}

async function fetchAdminInfo(adminID, failFunc) {
  const {data: adminInfoData, error} = await useAsyncData('getAdminInfo', () => getAdminInfo(adminID, failFunc));
  if (error.value) {
    await router.push({path: '/'});
    return null;
  }
  return adminInfoData.value;
}

async function fetchSpaceList(pagination, selectSpaceType, adminID, failFunc) {
  const {
    data: spaceListData,
    error
  } = await useAsyncData('getAdminSpaceList', () => getSpaceList(pagination, selectSpaceType, adminID, failFunc));

  if (error.value) {
    await router.push({path: '/'});
    console.error('Failed to fetch space list', error.value);
    return null;
  }

  return spaceListData.value?.list || [];
}

function setSeoMeta(adminInfo, spaceList) {
  if (!adminInfo || !Array.isArray(spaceList) || spaceList.length === 0) {
    return;
  }

  const seoMeta = {
    title: `${adminInfo.brand_name} | 線上預約！空間便利店場地租借平台`,
    description: `${spaceList[0].introduction}`,
    keywords: `${handleSpaceTypeUsageString(spaceList[0].categories)}`,
    ogTitle: `${adminInfo.brand_name} | 線上預約！空間便利店場地租借平台`,
    ogSiteName: '空間便利店',
    ogDescription: `${spaceList[0].introduction}`,
    ogImage: `${picUrl.value + spaceList[0].photos[0].url}`,
    ogImageAlt: `${adminInfo.brand_name} | 線上預約！空間便利店場地租借平台`,
    ogUrl: 'https://www.onestep.place',
    ogType: 'website',
  };

  useSeoMeta(seoMeta);
}

adminInfo.value = await fetchAdminInfo(Number(route.params.adminID), serverGoHome);

const selectSpaceType = -1;
const pagination = {dir: 1, limit: 0, sort: ''};
spaceList.value = await fetchSpaceList(pagination, selectSpaceType, Number(route.params.adminID), serverGoHome);

setSeoMeta(adminInfo.value, spaceList.value);


onMounted(() => {
  if (route.params.adminID) {
    router.push({query: null});
    settingStore.updateHomeRouter(`/admin/${route.params.adminID}`)
    isMobile.value = settingStore.isMobile;

    if (spaceList.value.length === 0) {
      router.push('/')
    }

  } else {
    router.push('/')
  }
})

const handleSpaceDetail = (spaceid) => {
  router.push({path: '/admin-space/' + spaceid})

}

function handleSpaceTypeArray(categories) {
  const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID

  return categories[typeCategoryId] ? categories[typeCategoryId] : []
}

function handleSpaceUsageArray(categories) {
  const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID
  return categories[usageCategoryId] ? categories[usageCategoryId] : []
}

function handleSpaceTypeUsageString(categories) {
  return handleSpaceTypeArray(categories).map(item => item.name).join('、') + ' , ' +
      handleSpaceUsageArray(categories).map(item => item.name).join('、')
}

</script>
<style scoped
       lang="scss">

.admin-wrap {
  @apply mx-auto
  md:w-[1280px]
  w-full;

  .space-list-scroll {
    @apply pc:pt-5 w-full flex flex-wrap justify-start
    md:px-[55px]
    px-0;


    /*pc版本*/
    .pc-wrap {
      @apply pc:w-full;
      .banner {
        @apply w-full;
        img {
          @apply mx-auto w-full rounded-[10px] aspect-[4/1];
          object-fit: cover;
        }
      }

      .admin-logo {
        @apply max-w-[250px]
      }

      .brand-name {
        @apply flex items-center justify-center text-[38px] font-[500] text-osn-dark-grey-00;
      }

      .banner-text {
        @apply px-6 py-3  text-[16px] text-osn-grey-01;

        white-space: pre-line;
        font-size: 16px; /* 可自行設定字體大小 */
        line-height: 1.5; /* 設定行高 */

      }
    }

    /*pc版本*/
    /*.pc-space-wrap {
      @apply w-full h-fit flex my-[30px];

      .img-wrap {
        @apply w-2/3 max-w-[650px] h-[435px] relative rounded-[10px] mr-[30px];
        :deep(.swiper-button-prev ), :deep(.swiper-button-next) {
          @apply w-[30px] h-[30px] bg-white rounded-full text-black text-[10px];

          &::after {
            @apply text-[20px];
          }
        }

        :deep(.swiper-pagination-bullet-active) {
          @apply bg-osn-yellow-00;
        }

        img {
          @apply rounded-[10px] w-full h-[435px] object-cover;

        }
      }

      .space-info {
        @apply w-1/2 flex flex-col justify-between;
        .space_name {
          @apply text-[24px] font-[500] text-osn-dark-grey-00;
        }

        .address {
          @apply text-[18px] text-osn-grey-01 mr-[4px] mt-[2px];
        }

        .mrt {
          @apply text-[16px] text-osn-dark-grey-00 ml-[4px] mt-[2px];
        }

        .tag {
          @apply mr-[4px] px-[10px] py-[2px] text-[14px] text-osn-white-00 rounded-full bg-osn-dark-grey-00 mt-[3px];
        }

        .desc {
          @apply max-w-full mt-[16px] p-[16px] text-[16px] text-osn-grey-01 bg-osn-grey-04 whitespace-pre-line break-all;
          span {
            @apply line-clamp-5;
          }
        }

        .price {
          @apply flex text-[30px] text-osn-dark-grey-00 font-[500];
          .unit {
            @apply text-[16px] text-osn-grey-01 font-[400];
          }
        }

        .less {
          @apply flex text-[16px] text-osn-grey-01 mb-[8px];
        }

        .book-btn {
          @apply flex items-center justify-center w-full h-[50px] text-[20px] text-osn-dark-grey-00 font-bold bg-osn-yellow-00 rounded-[50px];
        }
      }
    }*/

    /*手機版*/
    .space-wrap {
      @apply m-[5px] rounded-[10px] overflow-hidden
      md:w-[380px]
      w-full;

      .banner {
        img {
          @apply mx-auto w-auto rounded-[10px] aspect-[4/1];
          object-fit: cover;
        }
      }

      .brand-name {
        @apply text-[26px] font-bold text-osn-dark-grey-00;
      }

      .banner-text {
        @apply px-6 py-3  text-[16px] text-osn-grey-01;

        white-space: pre-line;
        font-size: 16px; /* 可自行設定字體大小 */
        line-height: 1.5; /* 設定行高 */

      }

      .img-wrap {
        @apply mb-[8px] relative rounded-[10px];
        :deep(.swiper-pagination-bullet-active) {
          @apply bg-osn-yellow-00;
        }

        img {
          @apply aspect-[1024/683] rounded-[10px]
          md:max-w-[380px] md:px-0
          w-full px-[5px];

          //object-fit: cover;
          //object-position: center;
        }

        .tag {
          @apply w-fit text-[12px] leading-[21px] px-[8px] rounded-[5px] text-white;
          background: var(--others-opacity-50, rgba(34, 34, 34, 0.50));
        }

        .tag-wrap {
          @apply absolute top-[12px] right-[12px];
          div {
            @apply mb-[4px]
          }
        }

      }


      .space-info {
        @apply flex flex-col px-[8px] pb-[13px];

        .top-wrap {
          @apply w-full px-[4px] flex justify-between;
          .space_name {
            @apply text-[18px] leading-[20px];
            color: var(--dark-1, #222);
          }

          .rent-wrap {
            @apply flex;
            .rent-type {
              @apply text-[14px] leading-[20px] rounded-[5px] px-[4px];
              margin-left: 8px;
              border: 1px solid var(--dark-3, #77746E);
              color: var(--dark-3, #77746E);
            }
          }
        }

        .bottom-wrap {
          @apply flex items-center justify-between;
          .left-wrap {
            .address {
              @apply px-[4px] w-fit mt-[3px] text-[16px] leading-[20px] text-os-gray-700;
            }

            .price {
              @apply px-[4px] w-fit mt-[3px] text-[17px] leading-[20px] font-[500] text-os-gray-900;
            }
          }

          .right-wrap {
            @apply w-fit min-w-[100px] text-center h-[35px] leading-[35px]
            px-[18px] rounded-[50px] bg-white text-blue-700 border border-blue-700 text-[14px];

          }
        }
      }

    }

    .space-wrap:first-child {
      .img-wrap {
        @apply mt-0;
      }
    }
  }
}


</style>
